<style scoped>
.mt-70px{
    margin-top: 70px;
}
</style>
<template>
    <div class="container mt-70px">

        <div class="row">
    
            <!-- Blog Entries Column -->
            <div class="col-md-8 mt-2" id="BlogPosts">
            <h1 class="my-4"><a href="/externalBlog"><i class="fas fa-blog"></i>
                <small class="text-uppercase" style="font-family: 'Libre Baskerville', serif; color: #3e4095; text-shadow: white 0.5px 0.5px 0.5px; letter-spacing: -4px;vertical-align: text-middle; font-size: 25px">Grupo&nbsp; Super&nbsp; Safra</small></a>
            </h1>
            <blog-card
                v-for="post in blogInfo.data"
                v-bind:key="post.id"
                v-bind:blogPost="post"
            ></blog-card>
    
            <!-- Pagination -->
            <div class="d-flex justify-content-center">
                <pagination :data="blogInfo" @pagination-change-page="getResults"></pagination>
            </div>
    
            </div>
    
            <!-- Sidebar Widgets Column -->
            <div class="col-md-4">
    
            <procura-card></procura-card>
    
            <categorias-widget></categorias-widget>

            <tags-widget></tags-widget>            
    
            </div>
    
        </div>
        <!-- /.row -->

    </div>
</template>

<script>
    import BlogCard from "./BlogCard.vue";
    export default {
        data(){
            return {
                blogInfo: {},
            }
        },
        mounted() {
            this.getResults();
            $('.back-to-top').click();
            jQuery(document).ready(function($) {

                if (window.history && window.history.pushState && typeof window.post === 'undefined') {

                    window.history.replaceState('externalBlog', null, './externalBlog');

                    $(window).on('popstate', function() {
                        Fire.$emit('voltar');
                    });

                }

                if (window.history && window.history.pushState && typeof window.post !== 'undefined') {

                    window.history.replaceState({}, null, null);

                    $(window).on('popstate', function() {
                        Fire.$emit('voltar');
                    });

                }
            });
        },
        methods:{
            getResults(page = 1) {
                this.$Progress.start();
                axios.get('/api/blog?page='+page)
                    .then(response => {
                        this.$Progress.finish();
                        this.blogInfo = response.data;
                    });
                $('.back-to-top').click();
            },
            viewPost(post){
                this.$parent.viewPost(post);
            },
            backToNormal(){
                this.$parent.backToNormal();
            },
            viewPostsFromCategory(data){
                this.$parent.viewPostsFromCategory(data);
            },
            viewPostsFromTag(data){
                this.$parent.viewPostsFromTag(data);
            }
        },
        components: {
            'blog-card': BlogCard
        },
        watch: {
            
        }
    }
</script>
